const locales = {
  "ja": {
    "tour_mae_maas_link" : "Mae MaaSに戻る",
    "tour_copyright_first" : "© 2021-",
    "tour_copyright" : "Maebashi city",
    "tour_back" : "戻る",
    "tour_pass_benefit" : "パス特典",
    "tour_shop_information" : "店舗情報",
    "tour_station_information" : "ステーション情報",
    "tour_tolocca" : "To Locca",
    "tour_times_carshare" : "タイムズカーシェア",
    "tour_location" : "所在地",
    "tour_tel" : "電話番号",
    "tour_holoday" : "定休日",
    "tour_website" : "公式サイト",
    "tour_business_hours" : "営業時間",
    "tour_nearest_station" : "最寄駅",
    "tour_nearest_busstop" : "最寄バス停",
    "tour_cancel" : "キャンセル",
    "tour_map_location_error_msg" : "現在地情報を取得できませんでした。お使いのブラウザでは現在地情報を利用できない可能性があります。エリアを入力してください。",
    "tour_map_denied_err_msg" : "位置情報の利用が許可されていません",
    "tour_map_position_err_msg" : "現在位置が取得できませんでした",
    "tour_map_timeout_error_message" : "タイムアウトになりました",
    "tour_map_default_error_message" : "現在位置が取得できませんでした",
    "tour_filter_title" : "フィルタ",
    "tour_genre_title" : "ジャンル",
    "tour_search_place" : "このエリアを検索",
    "tour_duration_label" : "{label}から往復で約{duration}分",
    "tour_duration_before_label" : "前の予定",
    "tour_duration_current_label" : "今",
    "tour_map_search_placeholder" : "駅名・場所・住所を入力",
    "tour_genre_list_link" : "ジャンル一覧",
    "tour_login_error_message" : "<p>この操作をするにはログインが必要です。<br>まだ会員登録がお済みでない方は、<br>新規会員登録をしてください</p>",
    "tour_plan_label" : "旅行プラン",
    "tour_map_label" : "マップ",
    "tour_present_location" : "現在地",
    "tour_demachiyanagi_station" : "出町柳駅",
    "tour_filter_all_on" : "すべてオン",
    "tour_filter_all_off" : "すべてオフ",
    "tour_close_label" : "閉じる",
    "tour_mobaku_map" : "モバイル空間統計® 人口マップ",
    "tour_mobaku_map_message" : "モバイル空間統計®人口マップは㈱ドコモ・インサイトマーケティングが提供するサービスです",
    "tour_mobaku_map_message2" : "NTTドコモの携帯電話ネットワークの仕組みを利用し、日本の人口を確認できます。",
    "tour_mobaku_map_message3" : "本サービスは集団の人数のみを表す人口統計情報であるため、お客様個人を特定することはできません。",
    "tour_mobaku_web" : "モバイル空間統計®公式サイト",
    "tour_privacy" : "プライバシーポリシー",
    "tour_mobaku_about" : "データ仕様について",
    "tour_google_policy" : "Googleポリシーと規約",
    "tour_about_mobaku" : "モバイル空間統計®について",
    "tour_mae_maas" : "Mae MaaS",
    "tour_place_detail_open": "詳細はこちらをタップ",
    "tour_reserve_label": "デマンド交通予約"
  },
  "en": {},
  "zh-TW": {}
}

export default locales
